/**
 * Action for close the change status modal.
 */
export function closeChangeStatusModal() {
  return {
    type: 'CHANGE_STATUS_MODAL_CLOSE',
    payload: {}
  };
}

/**
 * Action for open the change status modal.
 */
export function openChangeStatusModal(payload) {
  return {
    type: 'CHANGE_STATUS_MODAL_OPEN',
    payload
  };
}

/**
 * Type of actions.
 */
export const ACTION = {
  INACTIVE: 0,
  ACTIVE: 1
};
